module.exports = __webpack_public_path__ + "img/contents.60e685d4.svg";